import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import EditPopUpOKButton from "./edit-pop-up-ok-Button";
import EditClosePopUpIcon from "./edit-close-pop-up-icon";
import EditPopUpBody from "./edit-pop-up-body";
import getCorePopUpStore from "../../../stores/core/core-popup-store";

const EditPopUp = withLiteObserverAndTheme<{ width: number }>((props) => {
  const { theme, width } = props;
  const { colors } = theme;
  const { options, existingValue } = getCorePopUpStore().getEditPopUpData();
  //@ts-ignore
  getCorePopUpStore().editPopUpValue.set(existingValue);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={width}
      height={1080}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={true}
        width={550}
        height={80}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.white}
        style={{
          zIndex: 5,
          position: "relative",
          borderRadius: 20
        }}
        onClick={() => {}}
      >
        <EditClosePopUpIcon />
        <EditPopUpBody options={options} />
        <EditPopUpOKButton />
      </ET3Div>
    </ET3Div>
  );
});

export default EditPopUp;
